export default {
  black: 'bg-black',
  blue: 'bg-blue',
  light: 'bg-light',
  peach: 'bg-peach',
  purple: 'bg-purple',
  aqua: 'bg-aqua'
}
